<!--  -->
<template>
  <div>
    <div class="platw_box">
      <div>{{ type == 1 ? '平台' : '用友' }}分成比例：</div>
      <div class="platw_box">
        <el-input-number
          v-model="num"
          :precision="5"
          :step="0.00001"
          :min="0.00001"
          :max="1"
        />
        <!-- <div class="baidasw">%</div> -->
      </div>
    </div>
    <el-button
      type="primary"
      class="dawbtn"
      @click="proportionsubmit"
    >确定</el-button>
  </div>
</template>

<script>
import {
  setproportion,
  set_yonyou_share_proportion
} from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: {},
  data() {
    return {
      num: 1,
      id: null,
      type: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    async proportionsubmit() {
      if (this.num === undefined) {
        this.$message.error('输入不能为空')
        return
      }
      const id = this.id
      const share_proportion = this.num
      let data = {}
      if (this.type === 1) {
        data = await setproportion(id, share_proportion)
      } else {
        data = await set_yonyou_share_proportion(id, share_proportion)
      }
      this.$message({
        message: '设置成功',
        type: 'success'
      })
      this.$emit('close')
      console.log('data', data)
    },
    send(val, type) {
      this.type = type
      this.id = val.id
      if (type === 1) {
        this.num = val.share_proportion
      } else {
        this.num = val.yonyou_share_proportion
      }
      console.log('val', val)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.platw_box {
  display: flex;
  align-items: center;
}
.baidasw {
  font-size: 15px;
  margin-left: 20px;
}
.dawbtn {
  margin-top: 20px;
  margin-left: 267px;
}
</style>
